module.exports = __webpack_public_path__ + "static/media/PT.77cea2ac.svg";